import React from 'react';
import WaveSurferContext from '../contexts/WaveSurferContext.js';
import useWavesurfer from '../hooks/useWavesurfer.js';

// TODO: research on ref usage
function WaveSurfer({ children, plugins = [], onMount, ...props }) {
    const wavesurfer = useWavesurfer({
        plugins,
        onMount,
        ...props
    });
    return /*#__PURE__*/ React.createElement(WaveSurferContext.Provider, {
        value: wavesurfer
    }, children);
}

export { WaveSurfer as default };
